//router	-	index.js



import { createRouter, createWebHistory } from 'vue-router';

import HomeView from '../views/HomeView.vue';
import DemoView from '../views/DemoView.vue';
import LoginView from '../views/LoginView.vue';
import AboutView from '../views/AboutView.vue';
import TestView from '../views/TestView.vue';
import CalculateView from '../views/CalculateView.vue';
import DemoVizView from '../views/DemoVizView.vue';
import ChangeDataView from '../views/ChangeDataView.vue';


const routes = [
	{
		path: '/',
		name: 'Home',
		component: HomeView
	},
	{
		path: '/login',
		name: 'Login',
		component: LoginView
	},
	{
		path: '/calculate',
		name: 'Calculate',
		component: CalculateView
	},
	{
		path: '/demo',
		name: 'Demo',
		component: DemoView
	},
	{
		path: '/about',
		name: 'About',
		component: AboutView
	},
	{
		path: '/changedata',
		name: 'ChangeData',
		component: ChangeDataView
	},
	{
		path: '/test',
		name: 'Test',
		component: TestView
	},
	{
		path: '/demoviz',
		name: 'DemoViz',
		component: DemoVizView
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
})

export default router
